import { render, staticRenderFns } from "./Calculator.vue?vue&type=template&id=1395dd82&scoped=true"
import script from "./Calculator.vue?vue&type=script&lang=js"
export * from "./Calculator.vue?vue&type=script&lang=js"
import style0 from "./Calculator.vue?vue&type=style&index=0&id=1395dd82&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1395dd82",
  null
  
)

export default component.exports